export default {"src":"/_next/static/media/popeyes-stars.4cf836eb.svg","height":121,"width":100,"blurWidth":0,"blurHeight":0};